export const mogioConfig = {
  appId: "5fd349de743c937905523eca",
  appKey: "d5ttbe1Z5WK4a0Xg9Kv7tc8QusQXpe54",
};
